export const CommercialModuleQuestions = [
    {
        header: 'KDO VŠECHNO BY SE MĚL ÚČASTNIT HODNOCENÍ KOMERČNÍHO POTENCIÁLU?',
        answers: [
            {
                content: 'Povinná je účast soudního znalce. ',
            },
            {
                content: 'Komerční potenciál posuzuje zásadně původce myšlenky.',
            },
            {
                content: 'Většinou se jedná o celý tým lidí, který by měl zahrnovat jak původce, tak externí experty, ekonomy a potenciální komerční partnery.',
                correct: true,
            },
        ],
    },
    {
        header: 'CO TO JE SHOWSTOPPER?',
        answers: [
            {
                content: 'Je to určitý faktor, nejčastěji regulatorní povahy, který ovlivňuje to, zda se myšlenka může či nemůže dostat na trh.',
                correct: true,
            },
            {
                content: 'Jedná se o jeden z faktorů, který ovlivňuje motivaci akademiků dát svůj nápad patentovat.',
            },
            {
                content: 'Pravidelná světová výstava, kde jsou každý rok představovány výsledky výzkumné a vývojové činnosti vysokých škol z celého světa.',
            },
        ],
    },
    {
        header: 'KTERÉ FAKTORY MAJÍ VLIV NA KOMERČNÍ POTENCIÁL NAŠÍ MYŠLENKY?',
        answers: [
            {
                content: 'Jedná se jak o tvrdé faktory – například ekonomické či technologické, tak o takzvané měkké – tj. motivační. ',
                correct: true,
            },
            {
                content: 'Nejdůležitějším faktorem je stabilita kurzu měny v oblastech, kde chceme své řešení nechat patentovat.',
            },
            {
                content: 'Komerční potenciál určuje především znalecký posudek.',
            },
        ],
    },
    {
        header: 'LENKA CHCE ZJISTIT PŘESNOU HODNOTU SVÉHO NÁPADU. TO DOSÁHNE JENOM ZNALECKÝM POSUDKEM.',
        answers: [
            {
                content: 'Ano, je však zapotřebí nechat udělat nejméně dva znalecké posudky a přesnou cenou je jejich průměr.',
            },
            {
                content: 'Znalecký posudek je pouze jednou z forem zjištění hodnoty duševního vlastnictví. U znaleckého posudku i ostatních metod se jedná pouze o odhad hodnoty. Tak se může velmi lišit a často nemusí znamenat komerční úspěch řešení.',
                correct: true,
            },
            {
                content: 'Znalecký posudek nelze u duševního vlastnictví použít – je možné ho použít pouze u hmotného majetku.',
            },
        ],
    },
];
